/// <reference types="vite-plugin-svgr/client" />
import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

Sentry.init({
    dsn: "https://7a3c38d324c9880712e69658ddb371bf@o4508919719723008.ingest.us.sentry.io/4508919925178369",
    enabled: import.meta.env.VITE_SENTRY_ENABLED === "true",
    sendDefaultPii: true,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? "development",
    enableLogs: true,
    tracesSampleRate: 0.1,
    integrations: [
        Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
        Sentry.captureConsoleIntegration({ levels: ["error"] }),
    ],
});

createRoot(document.getElementById("react")!).render(<App />);
